export default __webpack_public_path__ + "images/projects/dear-dictator/dear-dictator-poster.jpg";